import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";

export const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "S.no",
  },
  {
    id: "medicineName",
    numeric: false,
    disablePadding: true,
    label: "Medicine Name",
  },
  {
    id: "medicineType",
    numeric: true,
    disablePadding: false,
    label: "Type",
  },
  {
    id: "medicineDose",
    numeric: true,
    disablePadding: false,
    label: "Dose",
  },
  {
    id: "manufacturing",
    numeric: true,
    disablePadding: false,
    label: "Manufacture", 
  },
  {
    id: "count",
    numeric: true,
    disablePadding: false,
    label: "Medicine Count", 
  },
  {
    id: "active_status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  
  
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
export const LeadBulkuploadForm = [
  {
    tag: InputBox,
    label: "Upload Leads",
    type: "file",
    key_name: "file",
  },
];
